import type { ICategoryComparison } from "app/pages/industry-analysis/categories-context/CategoriesContext";

export interface IComparisonRow<TEntry> {
    id: string;
    name: string;
    color: string;
    forApi: string;
    entry: TEntry | null;
}

interface IApiEntry {
    category: string;
}

/**
 * Zip the categories selected by the user (preserving their selection order)
 * with the API response entries. Categories absent from the API response keep
 * their slot with `entry: null` so the table renders an N/A row for them.
 */
export const buildComparisonRows = <TEntry extends IApiEntry>(
    categories: ICategoryComparison[],
    entries: TEntry[] | undefined,
): IComparisonRow<TEntry>[] => {
    const entriesByKey = new Map<string, TEntry>();
    if (entries) {
        for (const entry of entries) {
            if (entry?.category) {
                entriesByKey.set(entry.category, entry);
            }
        }
    }

    return categories.map(({ id, category, color }) => ({
        id,
        name: category.text,
        color,
        forApi: category.forApi,
        entry: entriesByKey.get(category.forApi) ?? null,
    }));
};
